module.exports = __webpack_public_path__ + "media/images/expert__martina-moser-0c51577c6cb5eb858f6566aaae7bceb4.png";